import React from "react";
import { Skeleton } from "@mui/material";

type Props = {
  lines?: number;
};

export function ListItemSkeleton({ lines = 3 }: Props) {
  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderRadius: "10px",
        border: "1px solid #f0f0f0",
        padding: "14px",
      }}
    >
      <Skeleton
        variant="text"
        width="50%"
        height={24}
        animation="wave"
        style={{ marginBottom: "10px" }}
      />
      {Array.from({ length: lines }).map((_, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "6px 0",
          }}
        >
          <Skeleton variant="text" width="30%" animation="wave" />
          <Skeleton variant="text" width="30%" animation="wave" />
        </div>
      ))}
    </div>
  );
}

type ListProps = {
  count?: number;
  lines?: number;
};

export function ListItemSkeletonGroup({ count = 4, lines = 3 }: ListProps) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      {Array.from({ length: count }).map((_, index) => (
        <ListItemSkeleton key={index} lines={lines} />
      ))}
    </div>
  );
}
